import { useState, useEffect } from "react";
import { addAffiliate, getProducts } from "../../redux/apiCalls";
import { useDispatch } from "react-redux";
import { publicRequest } from "../../requestMethods";
import Select from "react-select";
import styled from "styled-components";
import moment from "moment";
import "./newAffiliate.css";

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    opacity: 0.75;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 100;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
`;

const Overlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(white, 0.5);
    visibility: visible;
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;
`;

const ModalItemContainer = styled.div`
    background-color: white;
    color: black;
    height: 120%;
    width: 100%;
    display: grid;
    border-radius: 20px;
    overflow: hidden;
`;

const TopBanner = styled.div`
background-image: url(receipt.jpg);
background-size: contain;
color: black;
height: 100%;
background-position: center;
`

export default function NewAffiliate() {
    const [inputs, setInputs] = useState({
        prepay: 0,
        discount: 0,
        usage: 0,
        maxUsage: 9999,
        flatDiscount: 0,
    });
    const [usersData, setUsersData] = useState([]);
    const [modalState, setModalState] = useState(false);
    const dispatch = useDispatch();

    const getUsers = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setUsersData(res.data);
    };

    useEffect(() => {
        if (usersData[0] === undefined) {
            getUsers();
        }
    }, [usersData]);

    useEffect(() => {
        getProducts(dispatch, "");
    }, [dispatch]);

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleChangeUsage = (e) => {
        setInputs((prev) => {
            return { ...prev, maxUsage: e.target.value };
        });
    };

    const handleUserFilter = (e) => {
        setInputs((prev) => {
            return { ...prev, userId: e.value };
        });
    };

    const handleClick = async (e) => {
        const affiliate = { ...inputs };
        if (affiliate.discount > 100) {
            alert("Discount % cannot be more than 100%");
            return;
        }
        if (affiliate.discount === undefined) {
            affiliate.discount = 0;
            return;
        }

        affiliate.discount =
            affiliate.discount !== undefined ? affiliate.discount : 0;

        e.preventDefault();
        try {
            addAffiliate(affiliate, dispatch);
        } catch (err) {
            console.log(err);
        }
    };

    const handleModalState = async () => {
        setModalState(true);
    };

    return (
        <>
            <div className="newProduct">
                <div className="pageHeader">
                    <h1 className="pageTitle">New Affiliate</h1>
                    <p className="pageDescription">Create promotional codes and affiliate programs</p>
                </div>

                <div className="newAffiliate-container">
                    <div className="addProductForm">
                    <div className="addProductItem">
                        <label className="black required">Affiliate Code</label>
                        <input
                            name="code"
                            type="text"
                            placeholder="Code"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="black required">Discount %</label>
                        <input
                            name="discount"
                            type="number"
                            placeholder="Discount"
                            value={inputs.discount}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="black required">Flat Discount (RM)</label>
                        <input
                            name="flatDiscount"
                            type="number"
                            placeholder="Flat Discount"
                            value={inputs.flatDiscount}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="black">Prepay</label>
                        <input
                            name="prepay"
                            type="number"
                            placeholder="Prepay"
                            value={inputs.prepay}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="black required">Usage</label>
                        <input
                            name="maxUsage"
                            type="number"
                            placeholder="Usage"
                            value={inputs.maxUsage}
                            onChange={handleChangeUsage}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className="black">User</label>
                        <Select
                            className="borderBlack"
                            options={usersData.map((user, i) => {
                                return {
                                    label: `${user.name} - ${user.phoneNumber} - ${user.email}`,
                                    value: user._id,
                                };
                            })}
                            placeholder={"Full Name / Phone / Email"}
                            onChange={handleUserFilter}
                            menuPortalTarget={typeof window !== 'undefined' && window.innerWidth <= 768 ? document.body : null}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 })
                            }}
                        />
                    </div>

                    <div className="addProductItem">
                        <label className="black">Expiry Date</label>
                        <input
                            name="expiryDate"
                            value={inputs.expiryDate}
                            type="date"
                            onChange={handleChange}
                        />
                    </div>
                    <button onClick={handleModalState} className="updateProductButton">
                        Create
                    </button>
                    </div>
                </div>
            </div>
            {modalState && (
                <OverlayContainer>
                    <ModalContainer
                        onClick={() => setModalState(false)}
                    ></ModalContainer>
                    <Overlay>
                        <ModalDetails>
                            <ModalItemContainer>
                                <TopBanner></TopBanner>
                                <div className="updateTitle">
                                    <form className="addProductForm">
                                        <div className="addProductItem samerow">
                                            <label className="black">Affiliate Code :</label>
                                            <label className="">{inputs.code}</label>
                                        </div>
                                        <div className="addProductItem samerow">
                                            <label className="black">Discount % :</label>
                                            <label className="">{inputs.discount}%</label>
                                        </div>
                                        <div className="addProductItem samerow">
                                            <label className="black">Flat Discount (RM) :</label>
                                            <label className="">RM {inputs.flatDiscount}</label>
                                        </div>
                                        <div className="addProductItem samerow">
                                            <label className="black">Prepay :</label>
                                            <label className="">RM {inputs.prepay}</label>
                                        </div>
                                        <div className="addProductItem samerow">
                                            <label className="black">Usage :</label>
                                            <label className="">{inputs.maxUsage}</label>
                                        </div>
                                        <div className="addProductItem samerow">
                                            <label className="black">Expiry Date :</label>
                                            <label className="">{inputs.expiryDate ? moment(inputs.expiryDate).format("YYYY-MM-DD") : "No expiry"}</label>
                                        </div>
                                        <div
                                            onClick={handleClick}
                                            className="updateProductButton"
                                        >
                                            Confirm
                                        </div>
                                    </form>
                                </div>
                            </ModalItemContainer>
                        </ModalDetails>
                    </Overlay>
                </OverlayContainer>
            )}
        </>
    );
}
